var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 4.5835L15.7336 12.9377C15.6016 15.0722 15.5357 16.1394 15.0007 16.9067C14.7361 17.2861 14.3956 17.6062 14.0006 17.8468C13.2017 18.3335 12.1325 18.3335 9.99392 18.3335C7.8526 18.3335 6.78192 18.3335 5.98254 17.8459C5.58733 17.6049 5.24667 17.2842 4.98223 16.9042C4.4474 16.1357 4.38287 15.0669 4.25384 12.9295L3.75 4.5835",
    stroke: "#77787B",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 4.58317H17.5M13.3797 4.58317L12.8109 3.40961C12.433 2.63005 12.244 2.24027 11.9181 1.99718C11.8458 1.94325 11.7693 1.89529 11.6892 1.85375C11.3283 1.6665 10.8951 1.6665 10.0287 1.6665C9.14067 1.6665 8.69667 1.6665 8.32973 1.8616C8.24842 1.90485 8.17082 1.95475 8.09774 2.01081C7.76803 2.26375 7.58386 2.6678 7.21551 3.47589L6.71077 4.58317",
    stroke: "#77787B",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.1632027b53c9ea6a6a1471e9a83232d6.svg";
export { ForwardRef as ReactComponent };